import _BaseController from 'Controllers/Web/_BaseController';
import ReadControllerVue from 'Vue/Web/Shop/Course/ReadController.vue';
import 'magnific-popup';
import 'magnific-popup/src/css/main.scss';
import Datalayer from 'Controllers/Web/Datalayer';

// import Vuetify from 'vuetify';
// import 'vuetify/dist/vuetify.min.css'; // 確保加載 Vuetify 的樣式
// import 'material-design-icons-iconfont/dist/material-design-icons.css';
// import '@mdi/font/css/materialdesignicons.css';

global.Controller = new (class extends _BaseController {
  EditVue?: Vue;
  // vuetify = new Vuetify({
  //   icons: {
  //     iconfont: 'mdiSvg' // 'mdi', 'mdiSvg', 'md', 'fa', 'faSvg'
  //   },
  //   theme: {
  //     dark: false, // 預設使用暗色主題
  //     themes: {
  //       light: {
  //         primary: '#1867c0',
  //         secondary: '#424242',
  //         accent: '#005caf',
  //         error: '#FF5252',
  //         info: '#2196F3',
  //         success: '#4CAF50',
  //         warning: '#FFC107'
  //       },
  //       dark: {
  //         primary: '#2196F3',
  //         secondary: '#424242',
  //         accent: '#FF4081',
  //         error: '#FF5252',
  //         info: '#2196F3',
  //         success: '#4CAF50',
  //         warning: '#FB8C00'
  //       }
  //     }
  //   }}); // create a new instance of Vuetify
  ready() {
    super.ready();

    this.EditVue = new Vue(ReadControllerVue);
    /* vuetify 導入 */
    // Make sure to pass the Vuetify instance to the Vue options
    // this.EditVue = new Vue({
    //   vuetify: this.vuetify, // use Vuetify instance here
    //   render: h => h(ReadControllerVue)
    // }).$mount('.bar-content');

    $('[data-toggle="tooltip"]').tooltip();

    const window_width = $(window).width();
    const window_height = $(window).height();

    // datalayer
    Datalayer.push(Json.datalayer);

    // 更多課程介紹
    $('.more-button').on('click', function () {
      $('.more-button').hide();
      $('.html-content').addClass('open');
      $('.content-close-btn').css('display', 'block');
    });

    // 課程介紹收合內容
    $('.content-close-btn').on('click', function () {
      $('.more-button').show();
      $('.html-content').removeClass('open');
      $('.content-close-btn').css('display', 'none');
    });

    // Modal
    $('.nologin').on('click', function () {
      $('#MsgModal').modal({ backdrop: 'static', keyboard: false });
    });

    $('.chapter-item').on('click', (event: Event) => {
      if ($(event.currentTarget).hasClass('active')) {
        $(event.currentTarget)
          .parent()
          .find('.chapter-item')
          .removeClass('active');
        $(event.currentTarget)
          .parent()
          .find('.unit-item')
          .slideUp(300);
      } else {
        $(event.currentTarget)
          .parent()
          .find('.unit-item')
          .slideDown(300);
        $(event.currentTarget)
          .parent()
          .find('.chapter-item')
          .addClass('active');
      }
    });

    // cart
    if (window_width < 769) {
      $(window).on('scroll', (event: Event) => {
        var height =
          $('.banner').outerHeight(true) +
          $('.read-info').outerHeight(true) +
          $('#first').outerHeight(true);

        if ($(event.currentTarget).scrollTop() >= height) {
          $('.cart-item.mobile').show();
        } else {
          $('.cart-item.mobile').hide();
        }
      });
    }

    // line
    $(window).on('scroll', (event: Event) => {
      var height = $('.banner').outerHeight(true);

      if ($(event.currentTarget).scrollTop() >= height) {
        $('.stickyBar').show();
      } else {
        $('.stickyBar').hide();
      }
    });

    $('.rating').on('click', () => {
      $('.rating-form').toggleClass('rating-open');
    });


    // 已在購物車中
    if ($('#courseType').val() == 2) {
      $('#addcart-btn').on('click', () => {
        $('#cart-btn, #addcart-btn').addClass('disnone');
        $('.cart-form, .alreadycart-button').removeClass('disnone');
        $('#origin-form').addClass('disnone');
        $('.bar-btn').addClass('disnone');
      });
    }

    // 單元點選出現影片
    // $('.unit-line.play').on('click', function () {
    //     $(this).addClass('active');
    //     $('.vedio-bg').show();
    //     $('body').css('overflow-y','hidden');
    // });

    // 關掉影片
    // $('.delete-icon').on('click', function () {
    //     $('.vedio-bg').hide();
    //     $('body').css('overflow-y','auto');
    // });

    // 16:9
    var videoHeight = $('.vedio-list').width() / 1.7777;

    if (window_width > 768) {
      $('.video').height(videoHeight);
    }

    var headHeight = $('.video-head').height() + $('.video').height();
    // console.log( videoHeight );
    if (window_width < 769) {
      $('.video-item').height(window_height - headHeight);
    }

    class CountdownTimer {
      private rootEle: any;
      private intervalId: any;
      private elements: { [key: string]: any } = {};

      constructor(private rootId: string, private countDownDate: number) {
        this.rootEle = $(rootId);
        this.initElements();
      }

      initElements() {
        const selectors = ['day', 'hour', 'minute', 'second'];
        selectors.forEach(selector => {
          this.elements[selector] = this.rootEle.find(`.${selector}`);
        });
        this.rootEle.find('.toDate').html(this.formatDate(this.countDownDate, 'YYYY-MM-DD'));
      }

      formatDate(timestamp, format) {
        const date = new Date(timestamp);

        const map = {
          'YYYY': date.getFullYear(),
          'MM': ('0' + (date.getMonth() + 1)).slice(-2),
          'DD': ('0' + date.getDate()).slice(-2),
          'HH': ('0' + date.getHours()).slice(-2),
          'mm': ('0' + date.getMinutes()).slice(-2),
          'ss': ('0' + date.getSeconds()).slice(-2),
        };

        return format.replace(/YYYY|MM|DD|HH|mm|ss/g, matched => map[matched]);
      }

      updateElements(el, value: string | number = '') {
        if (el && el.length) el.html(value.toString());
      }

      updateCountdown() {

        const distance = this.countDownDate - Date.now();

        const timeValues = {
          day: this.formatDate(distance, 'DD'),
          hour: this.formatDate(distance, 'HH'),
          minute: this.formatDate(distance, 'mm'),
          second: this.formatDate(distance, 'ss'),
        };

        for (const key in timeValues) {
          this.updateElements(this.elements[key], timeValues[key]);
        }

        if (distance < 0) {
          this.clear();
          clearInterval(this.intervalId);
        }
      }

      start() {
        this.updateCountdown();
        this.intervalId = setInterval(() => this.updateCountdown(), 1000);
      }

      clear() {
        for (const key in this.elements) {
          this.updateElements(this.elements[key]);
        }
      }
    }

    // 募資倒數計時
    if (Json.Course.crowdfundingEndAt) {
      const countDownDate = new Date(Json.Course.crowdfundingEndAt.replace(/-/g, '/')).getTime();
      const fundraisingCountdown = new CountdownTimer('#fundraising', countDownDate);
      fundraisingCountdown.start();
    }

    /* 許願池倒數 */
    if (Json.Course.CourseField.wishOrderToDate) {
      const countDownDate = new Date(Json.Course.CourseField.wishOrderToDate.replace(/-/g, '/')).getTime();
      const fundraisingCountdown = new CountdownTimer('#wishOrder', countDownDate);
      fundraisingCountdown.start();
    }
    // 初始化輪播
    $(window).on('load', () => {

      $('.courseCarousel .owl-carousel').owlCarousel({
        autoplay: false, // 自動撥放
        loop: false, // 圖片循環
        center: false, // 是否置中
        navText: [], // 箭頭預設文字消失
        nav: false, // 前後箭頭
        dot: true,
        margin: 10,
        responsive: {
          0: {
            items: 1,
          },
          480: {
            items: 2,
          },
          768: {
            items: 3,
          },
          1024: {
            margin: 20,
          },
        },
      });

      $('.productCarousel .owl-carousel').owlCarousel({
        autoplay: false, // 自動撥放
        loop: false, // 圖片循環
        center: false, // 是否置中
        navText: [], // 箭頭預設文字消失
        nav: false, // 前後箭頭
        dot: true,
        responsive: {
          0: {
            items: 1,
          },
          480: {
            items: 2,
          },
          768: {
            items: 3,
          },
        },
      });
    });

  }
})();
